import { Box } from "@mui/material";
import {
  OnboardingSteps,
  STEP_TO_CONTENT,
} from "Components/Onboarding/NaturalPerson/Steps/constants";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useState } from "react";

export const NaturalPersonOnboarding = () => {
  const [step, setStep] = useState<OnboardingSteps>(0);

  const goToNextStep = () => {
    if (step === OnboardingSteps.FinalStep) {
      return;
    }
    setStep((currentStep) => currentStep + 1);
  };

  // const goToPrevStep = () => {
  //   if (step === 0) {
  //     return;
  //   }
  //   setStep((currentStep) => currentStep - 1);
  // };

  const CurrentStep = STEP_TO_CONTENT[step];

  return (
    // <OnboardingLayout
    //   title={t(Resources.Onboarding.ProcessTitle)}
    //   onChevronClick={step > 0 ? goToPrevStep : undefined}
    // >
    <StyledPageWrapper>
      <Box height="100%" className="left-content">
        <PrimaryPaper sx={{ height: "100%", overflowX: "hidden" }}>
          <CurrentStep onNextStepRequested={goToNextStep} />
        </PrimaryPaper>
      </Box>
    </StyledPageWrapper>
    // </OnboardingLayout>
  );
};
